module.exports = __webpack_public_path__ + "media/img/photo1-879d4fb6.png";